import { render } from "./AttendanceLogsEdit.vue?vue&type=template&id=58c885b8"
import script from "./AttendanceLogsEdit.vue?vue&type=script&lang=js"
export * from "./AttendanceLogsEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__